// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3xXCX","container":"styles_container__3qY9Z","copyAccessToken":"styles_copyAccessToken__-Zy5t","submitModal":"styles_submitModal__zPGNE"};